module.exports = __webpack_public_path__ + "img/converter_station_count.bf6ce763.png";